var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pvp-btn',{attrs:{"disabled":!_vm.canFinishRound,"is-loading":_vm.isFinishProccess},on:{"click":_vm.handleButtonClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }